import {classNames} from "../../util/util-helpers";
import React from "react";
import {formatNumber} from "chart.js/helpers";
import {getDueReadings} from "./due-date-table-cell-utils";

const LINE_CLASS = "w-full inline-flex items-center justify-between px-2.5 py-1 text-xs font-medium pointer-events-none";

export default function DueDateTableCell({item}) {
    const {showDate, showOdometer, showHours, dateDueIn, odometerDue, hoursDue} = getDueReadings(item);

    return (
        <div className={"flex flex-col"}>
            {showDate && (
                <div className={LINE_CLASS}>
                    <span
                        className={
                            classNames(
                                !item.IsDateDue && !item.IsDateWarning ? "text-green-600" : undefined,
                                item.IsDateWarning && !item.IsDateDue ? "text-yellow-600" : undefined,
                                item.IsDateDue ? "text-red-500" : undefined,
                            )}
                    >
                        {formatNumber(dateDueIn, undefined) + " days"}
                    </span>
                </div>
            )}

            {showOdometer && (
                <div className={LINE_CLASS}>
                    <span
                        className={
                            classNames(
                                !item.IsOdometerWarning && !item.IsOdometerDue ? "text-green-600" : undefined,
                                item.IsOdometerWarning && !item.IsOdometerDue ? "text-yellow-600" : undefined,
                                item.IsOdometerDue ? "text-red-500" : undefined,
                            )}
                    >
                        {formatNumber(Math.round(odometerDue), undefined) + " mil."}
                    </span>
                </div>
            )}

            {showHours && (
                <div className={LINE_CLASS}>
                    <span
                        className={
                            classNames(
                                !item.IsHoursDue && !item.IsHoursWarning ? "text-green-600" : undefined,
                                item.IsHoursWarning && !item.IsHoursDue ? "text-yellow-600" : undefined,
                                item.IsHoursDue ? "text-red-500" : undefined,
                            )}
                    >
                        {formatNumber(Math.round(hoursDue), undefined) + " hours"}
                    </span>
                </div>
            )}
        </div>
    );
}
